import { render, staticRenderFns } from "./SequenceDiagram.vue?vue&type=template&id=2c9ac72c&"
import script from "./SequenceDiagram.vue?vue&type=script&lang=ts&"
export * from "./SequenceDiagram.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports